<template>
  <div class="main-content">
    <a-t-loader v-if="isLoadingAllInvoices"/>

    <template v-else>
      <div class="page-content">
        <div class="all-invoice-container">
          <section class="invoices-block">
            <div class="page-title">
              <h2>All Invoices</h2>
            </div>

            <div class="invoices_filter" :class="{'invoices_filter--sales': this.user.scope.includes('SALES')}">
              <div class="invoices_filter-number">
                <input type="text" placeholder="Invoice Number" v-model="filterSearchInvoice.invoiceNumber">
              </div>
              <div v-if="!this.user.scope.includes('SALES')" class="invoices_filter-managers">
                <v-select
                  v-model="filterSearchInvoice.userId"
                  :options="allClients"
                  :reduce="(item) => item.id"
                  :filterable="false"
                  :clearable="false"
                  :searchable="false"
                  label="firstName"
                  placeholder="Manager"
                  class="new-select"
                  :disabled="isMyInvoice"
                >

                  <template #open-indicator>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="5"
                        viewBox="0 0 8 5"
                        fill="none">
                      <path
                          d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
                          fill="#606060" />
                    </svg>
                  </template>
                  <template #option="option" >
                    <div class="select__item d-center">
                      <div class="managers-list__item__image h-object-fit">
                        <img
                            :src="`${API}/documents/share/images/${
                              allClients.find((u) => u.id === option.id)
                                ? allClients.find((u) => u.id === option.id).photo
                                : '797d11d3-ab79-4d9a-b68e-7410b4c1dd3c'
                            }?size=SMALL`"
                            alt="image" />
                      </div>
                      <span>{{ option.firstName }}</span>
                    </div>
                  </template>
                  <template #selected-option="option">
                    <div class="selected d-center">
                      <div class="managers-list__item__image h-object-fit">
                        <img
                            :src="`${API}/documents/share/images/${
                              allClients.find((u) => u.id === option.id)
                                ? allClients.find((u) => u.id === option.id).photo
                                : '797d11d3-ab79-4d9a-b68e-7410b4c1dd3c'
                            }?size=SMALL`"
                            alt="image" />
                      </div>
                      <span>{{ option.firstName }}</span>
                    </div>
                  </template>

                </v-select>
              </div>
              <div class="invoices_filter-payer">
                <input type="text" placeholder="Payer" v-model="filterSearchInvoice.payerName">
              </div>
              <div class="invoices_filter-date form-control-datepicker form-control-datepicker--labeled">
                <div class="form-control-group">
                    <span class="form-control-label">From:</span>
                  <div class="form-control-wrap">
                    <input
                        type="text"
                        ref="tourStart"
                        v-model="filterSearchInvoice.fromDeadlineDate"
                        @blur="
                          filterSearchInvoice.fromDeadlineDate = $event.target.value
                        "
                        Placeholder="Date From"
                        class="form-control js-datepicker-single" />
                    <div class="form-control-icon">
                      <svg
                          width="1em"
                          height="1em"
                          class="icon icon-calendar">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="form-control-group">
                    <span class="form-control-label">To:</span>
                  <div class="form-control-wrap">
                    <input
                        type="text"
                        ref="tourStart"
                        v-model="filterSearchInvoice.toDeadlineDate"

                        @blur="
                          filterSearchInvoice.toDeadlineDate = $event.target.value
                        "
                        Placeholder="Date To"
                        class="form-control js-datepicker-single" />
                    <div class="form-control-icon">
                      <svg
                          width="1em"
                          height="1em"
                          class="icon icon-calendar">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="invoices_filter-btns">
                <button @click="findAllInvoices">
                  <svg width="1em" height="1em" class="icon icon-search">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                  </svg>
                </button>
                <a class="story-templates__table__top-clear"
                    :style="{cursor: 'pointer'}"
                    @click="clearSearch"
                >
                  Clear
                </a>
              </div>
            </div>

            <div class="tabs-nav">
              <div class="tabs-nav__block">
                <a class="not-paid"
                   :class="['tabs-nav__item', {active: tab === 0}]"
                   @click="
                      pagination.page = 1
                      findTabs(0)
                    ">
                  <svg width="30px" height="30px"  class="icon">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#not-paid"></use>
                  </svg>
                  <span class="tabs-nav__text">Not Paid</span>
                </a>
                <a class="archive-paid"
                   :class="['tabs-nav__item', {active: tab === 1}]"
                   @click="
                    pagination.page = 1
                    findTabs(1)
                   ">
                  <svg width="30px" height="30px" class="icon">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#archive-paid"></use>
                  </svg>
                  <span class="tabs-nav__text">Paid Archive</span>
                </a>
                <a class="refund"
                   :class="['tabs-nav__item', {active: tab === 2}]"
                   @click="
                    pagination.page = 1
                    findTabs(2)
                  ">
                  <svg width="30px" height="30px"  class="icon">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#refund"></use>
                  </svg>
                  <span class="tabs-nav__text">Refund Cancelled</span>
                </a>
              </div>
              <div v-if="!user.scope.includes('ACCOUNTANT') && !this.user.scope.includes('SALES')"  class="invoices_filter-options">
                <div class="form-control-group make-story__checkbox">
                  <label class="form-control-checkbox">
                    <input type="checkbox" v-model="isMyInvoice"/>
                    <span class="form-control-checkbox__box">
                      <svg width="1em" height="1em" class="icon icon-check">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                      </svg>
                    </span>
                    <span class="form-control-checkbox__name form-control__help">
                      Only my Invoices
                    <span class="form-control__help-icon">
                      <span class="form-control__help-content">
                        Активируйте чек-бокс, чтобы увидеть все свои инвойсы.
                      </span>
                      <img src="/images/useful/svg/help-icon.svg" alt=""/>
                    </span>
                    </span>
                  </label>
                </div>
              </div>
            </div>

            <div class="invoices_list">
              <div class="invoices_list-top">
                <div class="invoices_list-top-number">
                  <span>Invoice #</span>
                  <svg width="30px" height="30px"  class="icon">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#top-bottom"></use>
                  </svg>
                </div>
                <div class="invoices_list-top-manager">
                  <span>Manager</span>
                </div>
                <div class="invoices_list-top-bank">
                  <span>Bank</span>
                </div>
                <div class="invoices_list-top-payer">
                  <span>Payer</span>
                </div>
                <div class="invoices_list-top-invoice-amount">
                  <span>Invoice Amount</span>
                </div>
                <div class="invoices_list-top-invoice-amount-paid">
                  <span>Amount Paid</span>
                </div>
                <div class="invoices_list-top-deadline">
                  <span>Deadline</span>
                  <svg width="30px" height="30px"  class="icon">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#top-bottom"></use>
                  </svg>
                </div>
                <div class="invoices_list-top-status">
                  <span>Status</span>
                </div>
                <div class="invoices_list-top-note">
                  <span>Note</span>
                </div>
                <div class="invoices_list-top-options"></div>
              </div>

              <a-t-loader v-if="isLoadingAllInvoices"/>

             <template v-else>
               <template v-if="allInvoices.length > 0">
                 <div class="invoices_item" v-for="invoice in allInvoices" :key="invoice.id">
                   <div class="invoices_item-number">
                     <router-link v-if="!user.scope.includes('ACCOUNTANT')" :to="{ name: 'changeInvoice', params: { id: invoice.id }}">
                        {{invoice.invoiceNumber}}
                     </router-link>
                     <router-link v-if="user.scope.includes('ACCOUNTANT')" :to="{ name: 'details-invoice', params: { id: invoice.id }}">{{invoice.invoiceNumber}}</router-link>
                   </div>
                   <div class="invoices_item-manager">
                     <div class="managers-list__item__image h-object-fit">
                       <img v-if="allClients.find((u) => u.id === invoice.userId)
                                ? allClients.find((u) => u.id === invoice.userId).photo
                                : null"
                           :src="`${API}/documents/share/images/${
                              allClients.find((u) => u.id === invoice.userId)
                                ? allClients.find((u) => u.id === invoice.userId).photo
                                : '797d11d3-ab79-4d9a-b68e-7410b4c1dd3c'
                            }?size=SMALL`"
                           alt="image" />
                       <span v-else></span>
                     </div>
                     <span>
                     {{allClients.find((u) => u.id === invoice.userId)
                         ? allClients.find((u) => u.id === invoice.userId).firstName
                         : ''}}
                   </span>
                   </div>
                   <div class="invoices_item-bank tooltip">
                    <span class="invoices_item-bank-name">
                     {{allBanks.find((u) => u.id === invoice.bankId)
                        ? allBanks.find((u) => u.id === invoice.bankId).shortName
                        : ''}}
                   </span>
                     <span class="tooltiptext">
                     {{allBanks.find((u) => u.id === invoice.bankId)
                         ? allBanks.find((u) => u.id === invoice.bankId).shortName
                         : ''}}
                   </span>

                   </div>
                   <div class="invoices_item-payer">
                      <span>
                        {{findNamePartners(invoice)}}
                      </span>
                   </div>
                   <div class="invoices_item-amount" @click="findCurrentTotalAmountInvoices(invoice)">
                     <span>{{numberWithCommas(invoice.totalAmountPayable)}}</span>
                     <span>{{ getCurrencySign(invoice.currencyType) }}</span>
                   </div>
                   <div
                       class="invoices_item-amount-paid"
                       :class="{'active': (invoice.status === 'PARTIALLY' && (+invoice.totalAmount > +invoice.amountPaid))}"

                   >
                     <span>{{numberWithCommas(invoice.amountPaid)}}</span>
                     <span>{{getCurrencySign(invoice.currencyType)}}</span>
                   </div>
                   <div
                       class="invoices_item-deadline"
                       :class="{'active': invoice.status === 'SENT' && parseDate(invoice.deadline) < now}"
                      >
                     <span>{{parseDateToString(invoice.deadline)}}</span>
                   </div>
                   <div class="invoices_item-status">
                          <span v-if="user.scope.includes('ACCOUNTANT')">
                            {{invoice.status}}
                          </span>
                     <v-select
                         v-if="!user.scope.includes('ACCOUNTANT')"
                         @input="selectedOption(invoice)"
                         v-model="invoice.status"
                         :options="statusInvoices"
                         :reduce="(item) => item.type"
                         :filterable="false"
                         :clearable="false"
                         :searchable="false"
                         label="name"
                         placeholder="Select status"
                         class="new-select"
                     >
                       <template #open-indicator>
                         <svg
                             xmlns="http://www.w3.org/2000/svg"
                             width="8"
                             height="5"
                             viewBox="0 0 8 5"
                             fill="none">
                           <path
                               d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
                               fill="#606060" />
                         </svg>
                       </template>
                       <template #option="option" >
                         <div class="select__item d-center">
                           <div v-if="option.type === 'PAID' || option.type === 'PARTIALLY'" class="select-trigger__circle select-trigger__circle-paid"></div>
                           <div v-if="option.type === 'REFUND'" class="select-trigger__circle select-trigger__circle-refund"></div>
                           <div v-if="option.type === 'SENT'" class="select-trigger__circle select-trigger__circle-sent"></div>
                           <div v-if="option.type === 'CANCEL'" class="select-trigger__circle select-trigger__circle-cancel"></div>
                           {{ option.name }}
                         </div>
                       </template>
                       <template #selected-option="option">
                         <div class="selected d-center">

                           <div v-if="option.type === 'PAID' || option.type === 'PARTIALLY'" class="select-trigger__circle select-trigger__circle-paid"></div>
                           <div v-if="option.type === 'REFUND'" class="select-trigger__circle select-trigger__circle-refund"></div>
                           <div v-if="option.type === 'SENT'" class="select-trigger__circle select-trigger__circle-sent"></div>
                           <div v-if="option.type === 'CANCEL'" class="select-trigger__circle select-trigger__circle-cancel"></div>
                           {{ option.name }}
                         </div>
                       </template>
                     </v-select>
                   </div>
                   <div class="invoices_item-note">
                     <svg
                         width="1em"
                         height="1em"
                         class="icon icon-info-invoices">
                       <use
                           xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-info-invoices"></use>
                     </svg>
                     <div class="invoices_item-note__body">
                       <div class="body__header">
                         <div class="body__header-date">
                           <span>Payment Method:</span>
                           <span>{{invoice.paymentMethod ? invoice.paymentMethod : ''}}</span>
                         </div>
                         <div class="body__header-date">
                           <span>Date of Payment:</span>
                           <span>{{invoice.dateOfPayment ? parseDateToString(invoice.dateOfPayment) : '' }}</span>
                         </div>
                       </div>
                       <div v-if="invoice.note.length > 0" class="body">
                         <div class="body__logo">
                           <svg
                               class="icon icon-info-invoices">
                             <use
                                 xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-info-invoices"></use>
                           </svg>
                           <span>Note</span>
                         </div>

                         <span>{{invoice.note}}</span>
                       </div>
                     </div>
                   </div>
                   <div v-if="!user.scope.includes('ACCOUNTANT')" class="invoices_item-options">
                     <button
                         type="button"
                         class="story-templates__table__dropdown-trigger"
                         :style="{position: 'relative'}"
                         @click="openMenu(invoice.id)"
                     >
                       <svg width="1em" height="1em" class="icon icon-more">
                         <use
                             xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-more"></use>
                       </svg>
                       <div class="col-invoice-options--active"
                            :class="{'edit-popup edit-popup--short': invoice.id === invoice.id}"
                            v-if="invoice.menu"
                            :style="{zIndex: 100, right: '-6px'}"
                       >
                         <div class="form-control-group">
                           <ul class="col-invoice-options__links">
                             <li>
                               <router-link :to="{ name: 'changeInvoice', params: { id: invoice.id }}">
                                 <svg
                                     width="1em"
                                     height="1em"
                                     class="icon icon-edit-invoices">
                                   <use
                                       xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit-invoices"></use>
                                 </svg>
                                 <span class="li-name">Edit</span>
                               </router-link>
                             </li>
                             <li @click="openLink('/invoice/shared/' + invoice.link)">
                                                        <span  class="form-control-action__icon icon--blue">
                                                          <svg width="1em" height="1em" class="icon icon-link">
                                                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-link">
                                                              </use>
                                                          </svg>
                                                        </span>
                               <span class="li-name">Get A Link</span>
                             </li>



                           </ul>
                           <button
                               type="button"
                               class="btn form-control-action"
                               @click="deleteCurrentInvoice(invoice)"
                           >
                                                            <span
                                                                class="form-control-action__icon icon--red">
                                                              <svg
                                                                  width="1em"
                                                                  height="1em"
                                                                  class="icon icon-close">
                                                                <use
                                                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use></svg></span
                                                            ><span class="form-control-action__text"
                           >Delete</span
                           >
                           </button>
                         </div>
                       </div>
                     </button>
                   </div>
                 </div>
               </template>
               <template v-else>
                 <div class="invoices_item-no">
                   <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M16.3752 13.124C16.7204 13.124 17.0002 12.8442 17.0002 12.499C17.0002 12.1538 16.7204 11.874 16.3752 11.874H16.3748C16.0296 11.874 15.75 12.1538 15.75 12.499C15.75 12.8442 16.0301 13.124 16.3752 13.124Z" fill="#77B017"/>
                     <path d="M19.5002 13.124C19.8454 13.124 20.1252 12.8442 20.1252 12.499C20.1252 12.1538 19.8454 11.874 19.5002 11.874H19.4998C19.1546 11.874 18.875 12.1538 18.875 12.499C18.875 12.8442 19.1551 13.124 19.5002 13.124Z" fill="#77B017"/>
                     <path d="M22.6252 13.124C22.9704 13.124 23.2502 12.8442 23.2502 12.499C23.2502 12.1538 22.9704 11.874 22.6252 11.874H22.6248C22.2796 11.874 22 12.1538 22 12.499C22 12.8442 22.2801 13.124 22.6252 13.124Z" fill="#77B017"/>
                     <path d="M30.5016 19.6976C30.4297 19.4463 30.3201 19.211 30.1795 18.998C31.3718 17.043 32 14.8053 32 12.4995C32 5.60727 26.3927 0 19.5005 0C16.2142 0 13.2201 1.27476 10.9866 3.3558C10.5161 2.90594 9.88256 2.64333 9.21709 2.64333C9.14072 2.64333 9.06453 2.6467 8.98879 2.65345C8.30869 1.78443 7.25142 1.25945 6.13634 1.25945C4.35029 1.25945 2.86254 2.56083 2.57174 4.26533C1.52022 4.38982 0.702065 5.28672 0.702065 6.37111C0.702065 7.54038 1.6489 8.49165 2.81279 8.49165H7.6599C7.23273 9.75029 7.00099 11.0983 7.00099 12.4995C7.00099 15.0523 7.77021 17.4287 9.08903 19.4093L0.804936 27.3482C0.801748 27.3513 0.798561 27.3544 0.795436 27.3575C-0.265145 28.4181 -0.265145 30.1439 0.795436 31.2045C1.32573 31.7348 2.02232 32 2.71892 32C3.41552 32 4.11211 31.7348 4.6424 31.2045C4.64553 31.2014 4.64865 31.1982 4.65172 31.195L12.5903 22.9107C14.5711 24.2296 16.9476 24.9989 19.5005 24.9989C21.4614 24.9989 23.3366 24.5583 25.0764 23.689H29.9688C31.0888 23.689 32 22.7778 32 21.6579C32 20.7221 31.364 19.9322 30.5016 19.6976ZM2.81285 7.24164C2.34625 7.24164 1.95208 6.84297 1.95208 6.37105C1.95208 5.89101 2.34262 5.50046 2.82267 5.50046H3.14521C3.49039 5.50046 3.77019 5.22066 3.77019 4.87549C3.77019 3.57079 4.83165 2.50933 6.13634 2.50933C6.97506 2.50933 7.73403 2.93925 8.16657 3.65948C8.31107 3.90003 8.59812 4.01484 8.86854 3.94015C8.98147 3.90903 9.09872 3.89322 9.21709 3.89322C9.55439 3.89322 9.87569 4.02534 10.1157 4.25195C9.32984 5.1451 8.66918 6.15087 8.16132 7.2417H2.81285V7.24164ZM3.75431 30.325C3.18071 30.894 2.25113 30.8925 1.67934 30.3207C1.10749 29.7489 1.10605 28.8193 1.67503 28.2457L7.33767 22.819L9.18084 24.6622L3.75431 30.325ZM10.0457 23.7595L8.24026 21.9539L9.83919 20.4216C10.3606 21.0564 10.9433 21.639 11.578 22.1605L10.0457 23.7595ZM8.25101 12.4994C8.25101 6.29643 13.2975 1.24989 19.5005 1.24989C25.7035 1.24989 30.7501 6.29643 30.7501 12.4994C30.7501 14.4934 30.2285 16.4303 29.2363 18.1391C28.8783 17.9485 28.4714 17.8406 28.0425 17.8406C28.0132 17.8406 27.9839 17.8411 27.9548 17.8421C28.9674 16.2446 29.5001 14.4086 29.5001 12.4995C29.5001 6.98571 25.0143 2.4999 19.5005 2.4999C17.8801 2.4999 16.2699 2.89726 14.8439 3.64904C14.5386 3.81003 14.4215 4.18802 14.5824 4.49338C14.7434 4.79868 15.1214 4.91567 15.4268 4.75481C16.6737 4.09727 18.0824 3.74978 19.5005 3.74978C24.325 3.74978 28.2501 7.67487 28.2501 12.4994C28.2501 14.1273 27.8077 15.6942 26.9656 17.0661C26.3793 16.6762 25.6826 16.4568 24.9618 16.4568C23.1757 16.4568 21.6879 17.7583 21.3972 19.4627C20.4509 19.5747 19.6937 20.3122 19.5515 21.2491C19.5352 21.2491 19.5182 21.2491 19.5005 21.2491C14.676 21.2491 10.7509 17.324 10.7509 12.4994C10.7509 11.0812 11.0983 9.6726 11.7556 8.42597C11.9166 8.1206 11.7996 7.74262 11.4942 7.58163C11.1889 7.42063 10.8109 7.53769 10.6499 7.84299C9.89825 9.26868 9.50089 10.8789 9.50089 12.4994C9.50089 18.0132 13.9866 22.499 19.5005 22.499C19.5927 22.499 19.6691 22.4988 19.7411 22.4975C20.0147 23.0591 20.5283 23.4821 21.1467 23.6309C20.6067 23.7095 20.0575 23.749 19.5005 23.749C13.2975 23.749 8.25101 18.7024 8.25101 12.4994ZM29.9689 22.4391H21.6382C21.1716 22.4391 20.7774 22.0404 20.7774 21.5685C20.7774 21.0884 21.168 20.6979 21.648 20.6979H21.9706C22.3157 20.6979 22.5955 20.4181 22.5955 20.0729C22.5955 18.7682 23.657 17.7068 24.9617 17.7068C25.8005 17.7068 26.5594 18.1367 26.9919 18.8569C27.1364 19.0975 27.4234 19.2123 27.6939 19.1375C27.8069 19.1063 27.9241 19.0906 28.0424 19.0906C28.7227 19.0906 29.295 19.621 29.3456 20.2982C29.3699 20.6244 29.6417 20.8766 29.9688 20.8766C30.3996 20.8766 30.75 21.2271 30.75 21.6579C30.75 22.0887 30.3996 22.4391 29.9689 22.4391Z" fill="#77B017"/>
                     <path d="M12.8713 6.49561C13.2165 6.49561 13.4963 6.21579 13.4963 5.87061C13.4963 5.52542 13.2165 5.24561 12.8713 5.24561H12.8708C12.5257 5.24561 12.2461 5.52542 12.2461 5.87061C12.2461 6.21579 12.5261 6.49561 12.8713 6.49561Z" fill="#77B017"/>
                   </svg>
                   <span class="title">No Results</span>
                   <span class="desc">There’s no invoices yet</span>
                 </div>
               </template>
             </template>
            </div>
          </section>
          <pagination
              :page="page"
              :pageCount="pageCount"
              @pageController="pageController"
          />
        </div>
      </div>
    </template>

    <at-modal-invoice-status-paid
        v-if="isModalInvoicePaid"
        :invoice="currentInvoiceModal"
        :has-client-contract="currentInvoiceClientHasContract"
        :is-admin="isAdmin"
        @closeModalInvoiceStatusPaidOptions="closeModalInvoiceStatusPaid"
    />
    <at-modal-invoice-status-partially-paid
        v-if="isModalInvoicePartiallyPaid"
        :invoice="currentInvoiceModal"
        :has-client-contract="currentInvoiceClientHasContract"
        :is-admin="isAdmin"
        @closeModalInvoiceStatusPartiallyPaidOptions="closeModalInvoiceStatusPartiallyPaid"
    />
    <at-modal-invoice-total-amount
        v-if="isModalInvoiceTotalAmount"
        :currentInvoice="currentInvoice"
        @closeModalInvoiceTotalAmountParams="closeModalInvoiceTotalAmount"
    />

  </div>
</template>

<script>
import Vuex from "vuex";
import {actionTypes as actionTypesInvoice, getterTypes as getterTypesInvoice} from "@/store/modules/invoices";
import ATLoader from "@/components/Loaders/Loader";
import {actionTypes as actionTypesAuth, getterTypes as getterTypesAuth} from "@/store/modules/auth";
import {API} from "@/utilites/api";
import {actionTypes as actionTypesBanks, getterTypes as getterTypesBanks} from "@/store/modules/banks";
import {actionTypes as actionTypesPartners, getterTypes as getterTypesPartners} from "@/store/modules/partners";
import {format, parse} from "date-fns";
import AtModalInvoiceTotalAmount from "@/components/invoices/Modal/ModalInvoiceTotalAmount";
import AtModalInvoiceStatusPaid from "@/components/invoices/Modal/ModalInvoiceStatusPiad";
import AtModalInvoiceStatusPartiallyPaid from "@/components/invoices/Modal/ModalInvoiceStatusPertiallyPaid";
import Lightpick from "lightpick";
import Pagination from "@/components/Pagination";
import {getCurrencySign} from '@/common/helpers/currency'
import apiSettings from '@/services/api.settings'
export default {
  name: 'ATAllInvoices',
  props: ['user'],
  beforeCreate() {
    document.title = 'All Invoices'
  },
  data() {
    return {
      isMyInvoice: false,
      isModalInvoiceTotalAmount: false,
      isModalInvoicePaid: false,
      isModalInvoicePartiallyPaid: false,
      currentInvoiceModal: {},
      currentInvoiceClient: {},
      currentInvoiceClientRequestId: 0,
      tab: 0,
      page: 1,
      pageCount: 0,
      now: Date.now(),
      API: API,
      statusInvoices: [
        {name: 'Sent', type: 'SENT'},
        {name: 'Paid', type: 'PAID'},
        {name: 'Partially Paid', type: 'PARTIALLY'},
        {name: 'Cancelled', type: 'CANCEL'},
        {name: 'Refund', type: 'REFUND'},
      ],
      currentInvoice: {},
      filterSearchInvoice: {
        clientId: null,
        userId: null,
        fromDeadlineDate: null,
        toDeadlineDate: null,
        payerName: null,
        invoiceNumber: null,
        statuses: ["SENT"],
      },
      pagination: {
        size: 25,
        page: 1
      }
    }
  },
  watch: {
    isMyInvoice(value) {
      if (value === true) this.filterSearchInvoice.userId = this.user.id
      if (value === false) this.filterSearchInvoice.userId = null

    },
    allInvoices() {
      this.pageCountHandler()
    }
  },
  components: {
    Pagination,
    AtModalInvoiceStatusPartiallyPaid, AtModalInvoiceStatusPaid, AtModalInvoiceTotalAmount, ATLoader},
  computed: {
    ...Vuex.mapGetters({
      allInvoices: getterTypesInvoice.allInvoices,
      sizeStatusInvoices: getterTypesInvoice.sizeStatusInvoices,
      filterAllInvoices: getterTypesInvoice.filterAllInvoices,
      allClients: getterTypesAuth.allClients,
      allBanks: getterTypesBanks.allBanks,
      allPartners: getterTypesPartners.allPartners,
      isLoadingAllInvoices: getterTypesInvoice.isLoadingAllInvoices,
      isLoadingAllClients: getterTypesAuth.isLoadingAllClients
    }),
    currentInvoiceClientHasContract() {
      return Boolean(this.currentInvoiceClient && this.currentInvoiceClient.contract)
    },
    isAdmin() {
      return Boolean(
          this.user &&
          this.user.scope &&
          this.user.scope.includes('ADMIN')
      )
    },
  },
  methods: {
    getCurrencySign,
    ...Vuex.mapActions({
      findSearchInvoices: actionTypesInvoice.findSearchInvoices,
      getAllClients: actionTypesAuth.getAllClients,
      getAllBanks: actionTypesBanks.findBanks,
      getAllPartners: actionTypesPartners.findPartners,
      updateInvoiceStatus: actionTypesInvoice.updateInvoiceStatus,
      getFilterAllInvoices: actionTypesInvoice.filterAllInvoices,
      deleteInvoice: actionTypesInvoice.deleteInvoice
    }),
    pageController(page) {
      this.page = page
      this.pagination.page = this.page
      this.findAllInvoices()
    },
    pageCountHandler() {
      this.pageCount = Math.ceil(this.sizeStatusInvoices / this.pagination.size)
    },
    clearSearch(){
      this.filterSearchInvoice.userId = null
      this.filterSearchInvoice.payerName = null
      this.filterSearchInvoice.fromDeadlineDate = null
      this.filterSearchInvoice.toDeadlineDate = null
      this.filterSearchInvoice.invoiceNumber = null

      this.isMyInvoice = false

      this.findAllInvoices()
    },
    searchInvoice(){
      if (typeof (this.filterSearchInvoice.invoiceNumber) === String) {
        this.filterSearchInvoice.invoiceNumber = this.filterSearchInvoice.invoiceNumber.length === 0
            ? null
            : this.filterSearchInvoice.invoiceNumber
      }
      this.findSearchInvoices({
        trackingTotalCount: true,
        filter: this.filterSearchInvoice,
        sort: {
          invoiceNumber: {
            order: "ASC"
          },
          deadline: {
            order: "ASC"
          }
        },
        pagination: {
          size: 25,
          page: this.pagination.page
        }
      }).then(() => this.findTabs(this.tab))
    },
    findNamePartners(invoice){
      if (invoice.payer.operatorId) {
        return this.allPartners.find(p => p.id === invoice.payer.operatorId).companyName
      }

      if (invoice.payer.participant) {
        return invoice.payer.participant
      }
    },
    updateDatePickers() {
      document.querySelectorAll('.lightpick').forEach((elem) => {
        elem.remove()
      })
      setTimeout(() => {
        document.querySelectorAll('.js-datepicker-single').forEach((item) => {
          const datePicker = new Lightpick({
            field: item,
            singleDate: true,
            lang: 'en',
            format: 'DD.MM.yyyy',
            onClose: function () {
              item.blur()
            },
            onSelect: function () {
              item.focus()
              item.blur()
            },
          })
          item.addEventListener('blur', () => {
            datePicker.hide()
          })
        })
      }, 1000)
    },
    selectedOption(invoice){
      if (invoice.status === 'PAID') {
        this.currentInvoiceModal = invoice
        this.loadCurrentInvoiceClient(invoice)
        this.isModalInvoicePaid = true
      }

      if (invoice.status === 'PARTIALLY') {
        this.currentInvoiceModal = invoice
        this.loadCurrentInvoiceClient(invoice)
        this.isModalInvoicePartiallyPaid = true
        // console.log(this.currentInvoiceModal)
      }

      if (invoice.status === 'CANCEL') {
        const payload = {
          param: {
            status: {
              type: invoice.status,
            },
            userId: invoice.userId
          },
          invoiceId: invoice.id
        }
        this.updateInvoiceStatus(payload).then(() => this.findAllInvoices())
      }

      if (invoice.status === 'REFUND') {
        const payload = {
          param: {
            status: {
              type: invoice.status,
            },
            userId: invoice.userId
          },
          invoiceId: invoice.id
        }
        this.updateInvoiceStatus(payload).then(() => this.findAllInvoices())
      }

      if (invoice.status === 'SENT') {
        const payload = {
          param: {
            status: {
              type: invoice.status,
            },
            userId: invoice.userId
          },
          invoiceId: invoice.id
        }
        this.updateInvoiceStatus(payload).then(() => this.findAllInvoices())
      }
    },
    loadCurrentInvoiceClient(invoice) {
      const requestId = ++this.currentInvoiceClientRequestId
      this.currentInvoiceClient = {}

      apiSettings.getClient({id: invoice.clientId})
          .then((response) => {
            if (requestId !== this.currentInvoiceClientRequestId) return
            this.currentInvoiceClient = response.data || {}
          })
          .catch(() => {
            if (requestId !== this.currentInvoiceClientRequestId) return
            this.currentInvoiceClient = {}
          })
    },
    parseDate(date) {
      if (!date) return
      return new Date(
          format(parse(date, 'dd.MM.yyyy', new Date()), 'yyyy, MM, dd')
      )
    },
    openMenu(id) {
      this.allInvoices.map((item) =>
          item.id === id ? item.menu = !item.menu : item.menu = false
      )
    },
    openLink(link) {
      // this.updateClientsHandler()
      window.open(link, '_blank')
    },
    deleteCurrentInvoice(invoice) {
      this.deleteInvoice({
        id: invoice.id
      }).then(() => this.searchInvoice())
    },
    findCurrentTotalAmountInvoices(invoice){
      this.currentInvoice = invoice
      this.isModalInvoiceTotalAmount = true
    },
    closeModalInvoiceTotalAmount(value) {
      this.isModalInvoiceTotalAmount = value
    },
    closeModalInvoiceStatusPaid(value){
      this.findAllInvoices()
      this.isModalInvoicePaid = value
    },
    closeModalInvoiceStatusPartiallyPaid(value){
      this.findAllInvoices()
      this.isModalInvoicePartiallyPaid = value
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    findTabs(index) {
      // this.getFilterAllInvoices(index)
      if (index === 0) {
        this.filterSearchInvoice.statuses = ["SENT"]
      }
      if (index === 1) {
        this.filterSearchInvoice.statuses = ["PAID", "PARTIALLY"]
      }
      if (index === 2) {
        this.filterSearchInvoice.statuses = ["CANCEL", "REFUND"]
      }
      this.findAllInvoices()
      this.tab = index
      this.page = 1
    },
    parseDateToString(date) {
      if (!date) return
      return format(parse(date, 'dd.MM.yyyy', new Date()), 'dd MMM yyyy')
    },
    findAllInvoices() {
      // console.log(this.user)
      this.findSearchInvoices(
          {
            trackingTotalCount: true,
            filter: {...this.filterSearchInvoice, userId: this.user.scope.includes('SALES') ? this.user.id : this.filterSearchInvoice.userId},
            sort: {
              invoiceNumber: {
                order: "ASC"
              },
              deadline: {
                order: "ASC"
              }
            },
            pagination: {
              size: 25,
              page: this.pagination.page
            }
          }
      ).then(() => {
        // this.findTabs(this.tab)
        this.findAllClients()
      })
    },
    findAllClients() {
      this.getAllClients()
    },
    findAllBanks() {
      this.getAllBanks()
    },
    findAllPartners() {
      this.getAllPartners().then(() => this.findAllInvoices())
    }
  },
  mounted() {
    this.findAllBanks()
    this.findAllPartners()
    this.updateDatePickers()
  }
}
</script>
